import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';

@Component({
  selector: 'lib-expandable-column',
  imports: [CommonModule, MatTableModule, MatIconModule],
  templateUrl: './expandable-column.component.html',
  styleUrl: './expandable-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableColumnComponent {
  expanded = signal(false);
  showIcon = input(true);

  toggleExpanded(): void {
    this.expanded.set(!this.expanded());
  }
}
